import { createReducer, on } from '@ngrx/store';
import { AuthAdminState, initialAuthAdminState } from './auth-admin.state';
import {
  InitAuthSetAdmin,
  loginAdmin,
  loginAdminFailure,
  loginAdminSuccess,
} from './auth-admin.actions';

export const loginAdminReducer = createReducer(
  initialAuthAdminState,
  on(InitAuthSetAdmin, (state, { entity }): AuthAdminState => {
    return {
      error: false,
      loading: false,
      entity: entity,
    };
  }),
  on(loginAdmin, (state): AuthAdminState => {
    return { ...state, loading: true };
  }),
  on(loginAdminSuccess, (state, { response }): AuthAdminState => {
    const res = response.response;
    if (!res) throw response.errorCode;

    const entity = {
      role: res.user.role,
      id: res.id,
      ttl: res.ttl,
      type: res.type,
      refreshToken: res.refreshToken,
      createdAt: res.createdAt,
      userID: res.userID,
      user: res.user,
    };

    return {
      error: false,
      loading: false,
      entity: entity,
    };
  }),
  on(loginAdminFailure, (state, { error }): AuthAdminState => {
    return {
      error: error,
      loading: false,
      entity: null,
    };
  })
);
